import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { env } from '@ivy/fts/envInfo/envInfo';
import { addStatistics } from '../api';
let HeadVideo = class HeadVideo extends Vue {
    constructor() {
        super(...arguments);
        this.isPlaying = false;
    }
    async videoPlay() {
        try {
            // 埋点-扫描海报二维码
            await addStatistics({
                activity_id: this.activityId,
                event_type: 'Click_VideoCover_xszd',
                p1: this.id,
                p2: env.type === 'ivydad' ? this.appName : 'h5',
                p3: this.userType,
            });
        }
        catch { }
        let video = this.$refs['video'];
        let playFn = () => {
            let playPromise = video.play();
            if (playPromise !== undefined) {
                playPromise.catch(error => { }).then(() => { });
            }
        };
        if (!this.isPlaying) {
            playFn();
        }
        this.isPlaying = !this.isPlaying;
    }
};
tslib_1.__decorate([
    Prop()
], HeadVideo.prototype, "videoPoster", void 0);
tslib_1.__decorate([
    Prop()
], HeadVideo.prototype, "videoUrl", void 0);
tslib_1.__decorate([
    Prop()
], HeadVideo.prototype, "appName", void 0);
tslib_1.__decorate([
    Prop()
], HeadVideo.prototype, "activityId", void 0);
tslib_1.__decorate([
    Prop()
], HeadVideo.prototype, "id", void 0);
tslib_1.__decorate([
    Prop()
], HeadVideo.prototype, "userType", void 0);
HeadVideo = tslib_1.__decorate([
    Component
], HeadVideo);
export default HeadVideo;
